import React from 'react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  return <section className="py-10 md:py-14 px-6 bg-white relative" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-122">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-cream p-6 md:p-8 rounded-2xl border-2 border-green-600/20 shadow-lg" data-id="element-123">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3 font-serif" data-id="element-124">
              Es para ti solo si...
            </h3>
            <ul className="space-y-3" data-id="element-125">
              {['Llevas más de un año esperando que él se decida.', 'Te da miedo hablar del futuro por no parecer "intensa".', 'Sabes que vales, pero te has perdido complaciendo.', 'Quieres claridad, no manipulación.', 'Estás lista para tomar una decisión con dignidad.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700 text-sm md:text-base" data-id="element-126">
                  <span className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-127">✓</span>
                  <span className="leading-relaxed" data-id="element-128">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-blush/50 p-6 md:p-8 rounded-2xl border-2 border-burgundy/20 shadow-lg" data-id="element-129">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3 font-serif" data-id="element-130">
              <span className="text-xl" data-id="element-131">❌</span> No es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-132">
              {['Buscas trucos para manipular a alguien.', 'Prefieres vivir en la comodidad de la incertidumbre.', 'No estás dispuesta a trabajar en ti misma.', 'Crees que el amor es suficiente sin acción.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700 text-sm md:text-base" data-id="element-133">
                  <span className="text-burgundy mt-0.5 flex-shrink-0" data-id="element-134">✕</span>
                  <span className="leading-relaxed" data-id="element-135">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}